<div class="backdrop-box-details booking-travler-pop">
  <div
    class="modal fade show traveler-popup-div"
    bsModal
    tabindex="-1"
    role="dialog"
    aria-labelledby="dialog-nested-name1"
    style="display: block"
  >
    <div class="modal-dialog modal-md modal-dialog-centered">
      <div class="modal-content last-thankyou">
        <div class="modal-body">
          <div class="thank-you-img">
            <img src="/assets/image/thankyou-confirm.png" alt="" />
          </div>
          <div class="thank-you-text">
            <h4>Thank You !</h4>
            <p>
              Your Booking Confirmation Details Will Be Sent Your Registration
              Mail Id
            </p>
          </div>
          <div class="thank-you-link">
            <a routerLink="/home">Back To Home</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
